// Structured Data Generator
// Dynamically generates JSON-LD structured data from contact constants

import { CONTACT_INFO } from '@constants/contact';

export const generateFinancialServiceStructuredData = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FinancialService',
    name: CONTACT_INFO.company.name,
    alternateName: `${CONTACT_INFO.company.name} - Mutual Fund Distributor`,
    description:
      'AMFI certified mutual fund distributor providing personalized investment advice, goal-based planning, and wealth building strategies for Indian investors.',
    url: CONTACT_INFO.social.website,
    logo: `${CONTACT_INFO.social.website}/logo-400x230.png`,
    image: `${CONTACT_INFO.social.website}/og-image.png`,
    telephone: CONTACT_INFO.phone.primary,
    email: CONTACT_INFO.email.general,
    address: {
      '@type': 'PostalAddress',
      streetAddress: CONTACT_INFO.address.street,
      addressLocality: CONTACT_INFO.address.city,
      addressRegion: CONTACT_INFO.address.state,
      postalCode: CONTACT_INFO.address.pincode,
      addressCountry: 'IN',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '19.8090173',
      longitude: '75.2902173',
    },
    openingHours: 'Mo-Fr 09:00-18:00',
    priceRange: 'Free Consultation',
    serviceType: 'Mutual Fund Distribution Services',
    areaServed: {
      '@type': 'Country',
      name: 'India',
    },
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'AMFI Certification',
      recognizedBy: {
        '@type': 'Organization',
        name: 'Association of Mutual Funds in India',
      },
    },
    makesOffer: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Mutual Fund Distribution',
          description:
            'Personalized mutual fund selection and portfolio management',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Goal-Based Financial Planning',
          description:
            'Customized investment strategies for specific financial goals',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'SIP Investment Planning',
          description: 'Systematic Investment Plan setup and management',
        },
      },
    ],
    sameAs: [CONTACT_INFO.social.website],
  };
};

export const generateFAQStructuredData = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: `What is ${CONTACT_INFO.company.name}?`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `${CONTACT_INFO.company.name} is an AMFI certified mutual fund distributor helping Indian investors build wealth through systematic and goal-based investment strategies.`,
        },
      },
      {
        '@type': 'Question',
        name: `How can I start investing with ${CONTACT_INFO.company.name}?`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `You can start by contacting us at ${CONTACT_INFO.phone.display} or ${CONTACT_INFO.email.general} for a free consultation. We'll help you create a personalized investment plan based on your financial goals.`,
        },
      },
      {
        '@type': 'Question',
        name: `What services does ${CONTACT_INFO.company.name} offer?`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We offer mutual fund distribution, goal-based financial planning, SIP investment planning, portfolio management, and ongoing investment advisory services.',
        },
      },
      {
        '@type': 'Question',
        name: `Is ${CONTACT_INFO.company.name} AMFI certified?`,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `Yes, ${CONTACT_INFO.company.name} is AMFI certified with ARN: ${CONTACT_INFO.amfi.arn}. We are authorized to distribute mutual fund products in India.`,
        },
      },
    ],
  };
};

export const generateServiceStructuredData = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mutual Fund Investment Services',
    description:
      'Comprehensive mutual fund distribution and investment advisory services for Indian investors',
    provider: {
      '@type': 'FinancialService',
      name: CONTACT_INFO.company.name,
      telephone: CONTACT_INFO.phone.primary,
      email: CONTACT_INFO.email.general,
      address: {
        '@type': 'PostalAddress',
        streetAddress: CONTACT_INFO.address.street,
        addressLocality: CONTACT_INFO.address.city,
        addressRegion: CONTACT_INFO.address.state,
        postalCode: CONTACT_INFO.address.pincode,
        addressCountry: 'IN',
      },
    },
    areaServed: {
      '@type': 'Country',
      name: 'India',
    },
    serviceType: 'Financial Services',
  };
};
